import React from 'react';
import { companyInfo } from '../data/mockData';
import { FooterCompany } from './footer/FooterCompany';
import { FooterLinks, FooterServices } from './footer/FooterLinks';
import { FooterContact } from './footer/FooterContact';
import { ComplianceBar } from './footer/ComplianceBar';

export const Footer = () => (
  <footer className="footer" data-testid="site-footer">
    <div className="footer-content">
      <FooterCompany />
      <FooterLinks />
      <FooterServices />
      <FooterContact />
    </div>

    <div className="footer-bottom" data-testid="footer-bottom">
      <div style={{ fontSize: '0.825rem', textAlign: 'center' }}>
        © {new Date().getFullYear()} {companyInfo.name}. All rights reserved.
      </div>
    </div>

    <ComplianceBar />
  </footer>
);
